import Cookies from 'js-cookie'

export default {
  async login (email, pass) {
    return await loginToMyBook(email, pass);
  },

  isAuthenticated () {
    return !!Cookies.get('session')
  },
}

async function loginToMyBook (email, pass) {
  // eslint-disable-next-line no-console
  let response = await fetch(
    'https://mybook-test.herokuapp.com/login',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({email, password: pass})
    }
  );

  return response.ok;
}